export const SITE_NAME = "LaneX Labs";
export const SITE_TAGLINE = "Building Digital Businesses for the Modern World";

export const SEO_MAP = {
  home: {
    title: `${SITE_NAME} — Websites, Software, Automation & Digital Transformation`,
    description:
      "LaneX Labs is the technology division of LaneX Holdings. Premium websites, e-commerce, custom software, automation and enterprise digital solutions built for ambitious businesses.",
    path: "/",
  },
  services: {
    title: `Services — ${SITE_NAME}`,
    description:
      "Seven interlocking practices under one roof: website development, e-commerce, software, automation, cloud & infrastructure, cybersecurity and ongoing support & maintenance.",
    path: "/services",
  },
  work: {
    title: `Our Work — Products & Client Success Stories | ${SITE_NAME}`,
    description:
      "Selected work across sectors — from our own products (SyncLyn, Quixia, Vaultxy) to bespoke client platforms including Yebs Import and Elrica Cleaning Services.",
    path: "/work",
  },
  industries: {
    title: `Industries We Serve — Healthcare, Finance, Retail & More | ${SITE_NAME}`,
    description:
      "Deep experience across fourteen sectors: healthcare, recruitment, construction, hospitality, retail, education, finance, legal, real estate, manufacturing, logistics and more.",
    path: "/industries",
  },
  about: {
    title: `About LaneX Labs — The Digital Arm of LaneX Holdings`,
    description:
      "A team of engineers, designers and operators building the software backbone of ambitious businesses. Learn our manifesto, principles and the numbers behind our work.",
    path: "/about",
  },
  insights: {
    title: `Insights — Writing from the Build Floor | ${SITE_NAME}`,
    description:
      "Long-form thinking on how software, design and operations combine into a durable advantage. Articles on enterprise websites, automation, portals and cybersecurity.",
    path: "/insights",
  },
  contact: {
    title: `Contact & Project Enquiry — ${SITE_NAME}`,
    description:
      "Instead of pricing pages we scope every project individually. Share your brief through our six-step enquiry form — we come back within 24 hours with a shaped estimate.",
    path: "/contact",
  },
  login: {
    title: `Sign In — Client Portal & Admin | ${SITE_NAME}`,
    description:
      "Access your LaneX Labs client portal for project tracking, invoices, support tickets, files and messaging. Administrators sign in here for the CMS console.",
    path: "/login",
  },
  register: {
    title: `Create Client Account — ${SITE_NAME}`,
    description:
      "Create a LaneX Labs client account to access your project portal, invoices, tickets and files. Free to set up in under a minute.",
    path: "/register",
  },
  privacy: {
    title: `Privacy Policy — ${SITE_NAME}`,
    description:
      "How LaneX Labs collects, uses and protects your personal information. Our commitment to transparent, GDPR-aligned privacy practices.",
    path: "/privacy",
  },
  terms: {
    title: `Terms & Conditions — ${SITE_NAME}`,
    description:
      "Terms & Conditions governing use of the LaneX Labs website and services, including engagement, delivery, payment and intellectual property.",
    path: "/terms",
  },
  careers: {
    title: `Careers — Build With Us | ${SITE_NAME}`,
    description:
      "Join LaneX Labs. We are always interested in exceptional engineers, designers and operators. Learn about open roles and how we work.",
    path: "/careers",
  },
  portal: {
    title: `Client Portal — ${SITE_NAME}`,
    description: "Your LaneX Labs client portal — projects, invoices, support tickets and messaging.",
    path: "/portal",
  },
  admin: {
    title: `Admin Console — ${SITE_NAME}`,
    description: "LaneX Labs internal CMS console for managing content, portfolio, leads and users.",
    path: "/admin",
  },
  hosting: {
    title: `Web Hosting Plans — Managed, Fast, Secure | ${SITE_NAME}`,
    description:
      "Managed web hosting engineered for performance and reliability. Free SSL, automated backups, CDN acceleration and 24/7 monitoring. Plans from £5 per month.",
    path: "/hosting",
  },
  email: {
    title: `Business Email Hosting — Custom-Domain Mailboxes | ${SITE_NAME}`,
    description:
      "Professional business email on your own domain. Anti-spam and anti-virus, shared calendars, mobile sync and enterprise-grade security. From £3 per mailbox per month.",
    path: "/email",
  },
};
